import Vue from 'vue';
import { Button } from 'vant';
import { Search } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Tag } from 'vant';
import { Icon } from 'vant';
import { Toast } from 'vant';
import { List } from 'vant';
import { Cell, CellGroup } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Grid, GridItem } from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { AddressEdit } from 'vant';
import { NavBar } from 'vant';
import { Image as VanImage } from 'vant';
import { Col, Row } from 'vant';
import { Sticky } from 'vant';
import { SubmitBar } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { Empty } from 'vant';
import { Stepper } from 'vant';
import { TreeSelect } from 'vant';
import { Tab, Tabs } from 'vant';
import { AddressList } from 'vant';
import { ContactList } from 'vant';
import { Form } from 'vant';
import { Field } from 'vant';
import { Popup } from 'vant';
import { Switch } from 'vant';
import { Area } from 'vant';
const plugins = [
  Button,
  Search,
  Swipe,
  SwipeItem,
  Tag,
  Icon,
  Toast,
  List,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Grid, 
  GridItem,
  Tabbar,
  TabbarItem,
  AddressEdit,
  NavBar,
  VanImage,
  Col,
  Row,
  Sticky,
  SubmitBar,
  Checkbox, 
  CheckboxGroup,
  Empty,
  Stepper,
  TreeSelect,
  Tab, 
  Tabs,
  AddressList,
  ContactList,
  Form,
  Field,
  Popup,
  Switch,
  Area
].forEach(plugin => Vue.use(plugin))



// WEBPACK FOOTER //
// ./src/vant/index.js